<li class="nav-separator"><span>{{label}}</span></li>
